import React from 'react'
import PropTypes from 'prop-types'
import Router from './routes'
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { Provider, connect } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import history from './store/history'
import Theme from './styles/Theme'
import Spinner from 'components/Spinner'
class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.auth.authenticated === false &&
      this.props.auth.authenticated === null
    ) {
      history.replace('/signin')
    } else if (
      nextProps.auth.authenticated === false &&
      this.props.auth.authenticated === true
    ) {
      history.replace('/signin')
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.auth !== this.props.auth) return true
    return false
  }

  render() {
    const { store, auth } = this.props
    if (auth.authenticated === null) {
      return (
        <Provider store={store}>
          <React.Fragment>
            <CssBaseline />
            <MuiThemeProvider theme={Theme}>
              <Spinner />
            </MuiThemeProvider>
          </React.Fragment>
        </Provider>
      )
    }
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <React.Fragment>
            <CssBaseline />
            <MuiThemeProvider theme={Theme}>
              <Router />
            </MuiThemeProvider>
          </React.Fragment>
        </ConnectedRouter>
      </Provider>
    )
  }
}
const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}
const mapActionCreators = {}

export default connect(mapStateToProps, mapActionCreators)(App)



// WEBPACK FOOTER //
// ./src/App.js